// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_b1-b";
export var colorBlue = "_b1-8";
export var colorDot = "_b1-0";
export var colorDotLarge = "_b1-2";
export var colorDotSmall = "_b1-1";
export var colorGreen = "_b1-7";
export var colorGrey = "_b1-3";
export var colorOrange = "_b1-5";
export var colorPink = "_b1-a";
export var colorPurple = "_b1-9";
export var colorRed = "_b1-4";
export var colorYellow = "_b1-6";